export default {
  'sysParam.securityRuleManagement': 'Security Rule Management',
  'sysParam.securityRule': 'Security Rule',
  'sysParam.paramName': 'Param Name',
  'sysParam.mask': 'Mask',
  'sysParam.currentValue': 'Current Value',
  'sysParam.userCodeCompositionRule': 'User Code Composition Rule',
  'sysParam.userCodeMin': 'User Code Minimum Length',
  'sysParam.userCodeMax': 'User Code Maximum Length',
  'sysParam.pwdCompositionRule': 'Password Composition Rule',
  'sysParam.pwdMinLength': 'Password Minimum Length',
  'sysParam.noRepeatPwdHistoryNumber': 'No-repeat Password History Number',
  'sysParam.pwdExpiryDate': 'Password Expiry Date',
  'sysParam.letterNumberCaseInsensitive': 'letters/numbers&case insensitive',
  'sysParam.letterAndNumberCaseInsensitive': 'letters+numbers&case insensitive',
  'sysParam.letterNumberCaseSensitive': 'letters/numbers&case sensitive',
  'sysParam.letterAndNumberCaseSensitive': 'letters+numbers&case sensitive',
  'sysParam.letterAddNumber': 'letters/numbers/(letters+numbers)',
  'sysParam.letterAndNumber': 'letters&numbers',
  'sysParam.letterAndNumberCapitalLetters': 'letters&numbers&capital letters',
  'sysParam.letterAndNumberSpecail': 'letters&numbers&special characters',
  'sysParam.letterAndNumberCapitalSpecial': 'letters&numbers&capital letters&special characters',
  'sysParam.close': 'Close',
  'sysParam.lower': 'Lower',
  'sysParam.low': 'Low',
  'sysParam.medium': 'Medium',
  'sysParam.high': 'High',
  'sysParam.higher': 'Higher',
  'sysParam.saveSuccess': 'Save Success'
}